module.exports = "../../../../platform/assets/pageMainIcon/icon-tongyong-4-green.svg";